import { HELPER_API_BASE_URL, OAUTH_LOGIN_API_BASE_URL } from "../utils";
import { responseHandler } from "./helper";

export const authService = {
    login,
};

async function login(username, password) {
    const data = {
        username: username,
        password: password,
    };

    const requestOptions = {
        method: "POST",
        body: JSON.stringify(data),
    };

    try {
        const helperAPILoginResponse = await helperAPILogin(requestOptions);
        const nodeAPILoginResponse = await nodeAPILogin(requestOptions);

        return {...helperAPILoginResponse, ...nodeAPILoginResponse };
    } catch (err) {
        throw "login_error";
    }
}

function helperAPILogin(requestOptions) {
    return fetch(`${HELPER_API_BASE_URL}/login`, requestOptions).then(
        responseHandler
    );
}

function nodeAPILogin(requestOptions) {
    const options = {
        ...requestOptions,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    };
    return fetch(`${OAUTH_LOGIN_API_BASE_URL}/login`, options).then(
        responseHandler
    );
}